// Vendor JS
import Debug from 'debug';

/**
 * Fired on the home page
 */
export default {
	init() {
		try {
			Debug(`cig:info:sage:route:home`)(`init start`);


		} catch (err) {
			Debug(`cig:error:sage:route:home`)(`Home Route init Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	},

	// Fires after init
	finalize() {
		try {
			Debug(`cig:info:sage:route:home`)(`finalize start`);

		} catch (err) {
			Debug(`cig:error:sage:route:home`)(`Home Route finalize Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	}
};
